/**
 * @generated SignedSource<<62b435ef829dd8c0eb8ef300f55ab0df>>
 * @relayHash 80b38c61856aa9f4a6b995173bb84757
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 80b38c61856aa9f4a6b995173bb84757

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type createCustomerInput = {
  billedHourlyRate?: string | null | undefined;
  billingAddress?: string | null | undefined;
  categoryId?: string | null | undefined;
  clientMutationId?: string | null | undefined;
  customerCategoryId?: string | null | undefined;
  displayName: string;
  email?: any | null | undefined;
  extraBillingItems?: ReadonlyArray<EditCustomerItemEntry | null | undefined> | null | undefined;
  importAddress?: string | null | undefined;
  importReference?: string | null | undefined;
  journeyItemId?: string | null | undefined;
  phoneNumbers?: ReadonlyArray<EditPhoneNumberEntry | null | undefined> | null | undefined;
  printName?: string | null | undefined;
  reference?: string | null | undefined;
  workItemId?: string | null | undefined;
};
export type EditPhoneNumberEntry = {
  displayName?: string | null | undefined;
  phoneNumber?: any | null | undefined;
  phoneNumberId?: string | null | undefined;
  remove?: boolean | null | undefined;
};
export type EditCustomerItemEntry = {
  amount: number;
  itemId: string;
};
export type CustomerCreator_CreateCustomerMutation$variables = {
  input: createCustomerInput;
};
export type CustomerCreator_CreateCustomerMutation$data = {
  readonly createCustomer: {
    readonly createdCustomerEdge: {
      readonly cursor: string;
      readonly node: {
        readonly displayName: string;
        readonly id: string;
        readonly printName: string;
        readonly reference: string | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"CustomerFatQuery_data" | "CustomerRow_customer">;
      } | null | undefined;
    };
  } | null | undefined;
};
export type CustomerCreator_CreateCustomerMutation = {
  response: CustomerCreator_CreateCustomerMutation$data;
  variables: CustomerCreator_CreateCustomerMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "printName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reference",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CustomerCreator_CreateCustomerMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "createCustomerPayload",
        "kind": "LinkedField",
        "name": "createCustomer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CustomerEdge",
            "kind": "LinkedField",
            "name": "createdCustomerEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Customer",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "CustomerFatQuery_data"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "CustomerRow_customer"
                  },
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CustomerCreator_CreateCustomerMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "createCustomerPayload",
        "kind": "LinkedField",
        "name": "createCustomer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CustomerEdge",
            "kind": "LinkedField",
            "name": "createdCustomerEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Customer",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "link",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "archived",
                    "storageKey": null
                  },
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "missingRequiredCheckFields",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "missingRecommendedCheckFields",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Statistics",
                    "kind": "LinkedField",
                    "name": "statistics",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "lastWeeks",
                            "value": 13
                          }
                        ],
                        "concreteType": "WeeklyStatistics",
                        "kind": "LinkedField",
                        "name": "weekly",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "profit",
                            "storageKey": null
                          }
                        ],
                        "storageKey": "weekly(lastWeeks:13)"
                      },
                      {
                        "alias": "lastYear",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "lastDays",
                            "value": 365
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "sumFor",
                        "storageKey": "sumFor(lastDays:365)"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "80b38c61856aa9f4a6b995173bb84757",
    "metadata": {},
    "name": "CustomerCreator_CreateCustomerMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "d127776a772a7ee541459115ab1b40d4";

export default node;
